import Image from 'next/image';
import warning from '@/assets/warning.png';
import Link from 'next/link';

export default function LocationWarning() {
  return (
    <div className="relative flex flex-col items-center gap-[30px]">
      
      <Image src={warning} alt="Warning" width={80} />
      <p className="text-center text-[#475569] text-sm sm:text-xl font-semibold px-2">
        Oh-oh, it looks like you've selected a state without our outlet. Contact
        customer service or try again!
      </p>
      <Link href="/support" className="w-full max-w-xs">
        <p className="bg-crunchies-red shadow text-white py-3 px-6 rounded-[14px] font-semibold text-center">
          Contact customer care
        </p>
      </Link>
    </div>
  );
}
